export const FLAG_GETTING_AGENCIES = 'FLAG_GETTING_AGENCIES';
export const GET_AGENCIES = 'GET_AGENCIES';
export const CLEAR_AGENCIES = 'CLEAR_AGENCIES';
export const FLAG_AGENCY_ACTIVITY = 'FLAG_AGENCY_ACTIVITY';
export const GET_AGENCY = 'GET_AGENCY';
export const CLEAR_AGENCY = 'CLEAR_AGENCY';
